import { clone } from "../../../../common/utils/helper";
import uuid from "react-uuid";

/**
 * This util takes a check box config like this
    const [checkboxes, setCheckboxes] = useState({
      'Okta Apps': { checked: false, value: 'Okta Apps' },
      'Okta Roles': { checked: false, value: 'Okta Roles' },
      'Okta Policies': { checked: false, value: 'Okta Policies' },
      'Okta Users': { checked: false, value: 'Okta Users' },
      'Okta User Type': { checked: false, value: 'Okta User Type' },
      'Okta Groups': { checked: false, value: 'Okta Groups' },
    });

  and filter outs the selected parts. 
 * @param {*} assetSchema 
 * @param {*} currentData 
 * @param {*} currentDataProperty 
 * @param {*} importMappingConfig 
 * @returns 
 */
export const getImportMappingJson = (assetSchema, currentData,currentDataProperty, importMappingConfig) => {
  //replace the input parametes in the json file
  let config = clone(importMappingConfig)
  config.schema.objectSchema.name = assetSchema.name;

  let objectTypes = config.schema.objectSchema.objectTypes[0].children;
  let mappings = config.mapping.objectTypeMappings;

  Object.keys(currentData[currentDataProperty]).forEach((key, index) => {
    if (currentData[currentDataProperty][key].checked === false) {
      //remove the mapping
      objectTypes = objectTypes.filter((item) => item.name !== key);
      mappings = mappings.filter((item) => item.objectTypeName !== key);
    } else {
      objectTypes = objectTypes.map((item) => {
        if (item.name === key) {
          item.name = currentData[currentDataProperty][key].value;
        }
        return item;
      });
      mappings = mappings.map((item) => {
        if (item.objectTypeName === key) {
          item.objectTypeName = currentData[currentDataProperty][key].value;
        }
        return item;
      });
    }
  });
  config.schema.objectSchema.objectTypes[0].children = objectTypes;
  config.mapping.objectTypeMappings = mappings;

  return config;
};

